// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Responsive NavBar */
@media screen and (max-width: 650px) {
  .restaurant {
    grid-template-columns: 1fr;
  }

  .menuDiv {
    display: flex;
    flex-direction: column-reverse;
  }

  .skip-link {
    left: 70%;
  }
  .hero__title {
    font-size: 2.75em;
    text-align: center;
  }


  .titleOne {
    font-size: 1.25em;
    padding: 20px;
    padding-bottom: 12px;
  }

  .titleTwo {
    font-size: 2.25em;
    padding-bottom: 12px;
  }

  .titleThree {
    font-size: 17px;
    padding: 15px;
  }

  .hero__text {
    font-size: 1em;
  }
  .app-bar .app-bar__navigation {
    background-color: rgb(44, 94, 54, 0.9);
  }

  .restaurant .restaurant__description {
    grid-column-start: 1;
    grid-column-end: 1;
  }

  .app-bar__brand {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .app-bar__brand h1 {
    margin: 0;
    padding-right: 70px;
  }

  footer {
    text-align: center;
  }
}
@media screen and (min-width: 650px) {
  .app-bar {
    grid-template-columns: 1fr auto;
    padding: 1px 29px;
    padding-top: 10px;
  }

  .app-bar .app-bar__menu {
    display: none;
  }

  .app-bar .app-bar__navigation {
    display: flex;
    align-items: center;
    position: static;
    width: 100%;
  }

  .app-bar .app-bar__navigation ul {
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .app-bar .app-bar__navigation ul li {
    margin-right: 10px;
  }

  .app-bar .app-bar__navigation ul li a {
    display: inline-block;
    width: 120px;
    text-align: center;
    font-size: 1.1em;
    padding-top: 12px;
  }
}

@media screen and (min-width: 740px) {
  .app-bar {
    grid-template-columns: 1fr auto;
    padding: 1px 29px;
    padding-top: 10px;
  }

  .app-bar .app-bar__menu {
    display: none;
  }

  .app-bar .app-bar__navigation {
    position: static;
    width: 100%;
  }

  .app-bar .app-bar__navigation ul li {
    display: inline-block;
  }

  .app-bar .app-bar__navigation ul li a {
    display: inline-block;
    width: 120px;
    text-align: center;
    font-size: 1.1em;
    padding-top: 14px;
  }
}

/* Set the grid */
@media screen and (min-width: 505px) {
  .restaurant {
    grid-template-columns: repeat(1, 1fr);
  }
}

@media screen and (min-width: 650px) {
  .restaurant {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media screen and (min-width: 950px) {
  .restaurant {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (min-width: 1200px) {
  .restaurant {
    grid-template-columns: repeat(4, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/responsive.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,SAAS;EACX;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;;EAGA;IACE,iBAAiB;IACjB,aAAa;IACb,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;EACA;IACE,sCAAsC;EACxC;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;EACpB;AACF;AACA;EACE;IACE,+BAA+B;IAC/B,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA,iBAAiB;AACjB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Responsive NavBar */\n@media screen and (max-width: 650px) {\n  .restaurant {\n    grid-template-columns: 1fr;\n  }\n\n  .menuDiv {\n    display: flex;\n    flex-direction: column-reverse;\n  }\n\n  .skip-link {\n    left: 70%;\n  }\n  .hero__title {\n    font-size: 2.75em;\n    text-align: center;\n  }\n\n\n  .titleOne {\n    font-size: 1.25em;\n    padding: 20px;\n    padding-bottom: 12px;\n  }\n\n  .titleTwo {\n    font-size: 2.25em;\n    padding-bottom: 12px;\n  }\n\n  .titleThree {\n    font-size: 17px;\n    padding: 15px;\n  }\n\n  .hero__text {\n    font-size: 1em;\n  }\n  .app-bar .app-bar__navigation {\n    background-color: rgb(44, 94, 54, 0.9);\n  }\n\n  .restaurant .restaurant__description {\n    grid-column-start: 1;\n    grid-column-end: 1;\n  }\n\n  .app-bar__brand {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .app-bar__brand h1 {\n    margin: 0;\n    padding-right: 70px;\n  }\n\n  footer {\n    text-align: center;\n  }\n}\n@media screen and (min-width: 650px) {\n  .app-bar {\n    grid-template-columns: 1fr auto;\n    padding: 1px 29px;\n    padding-top: 10px;\n  }\n\n  .app-bar .app-bar__menu {\n    display: none;\n  }\n\n  .app-bar .app-bar__navigation {\n    display: flex;\n    align-items: center;\n    position: static;\n    width: 100%;\n  }\n\n  .app-bar .app-bar__navigation ul {\n    display: flex;\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n\n  .app-bar .app-bar__navigation ul li {\n    margin-right: 10px;\n  }\n\n  .app-bar .app-bar__navigation ul li a {\n    display: inline-block;\n    width: 120px;\n    text-align: center;\n    font-size: 1.1em;\n    padding-top: 12px;\n  }\n}\n\n@media screen and (min-width: 740px) {\n  .app-bar {\n    grid-template-columns: 1fr auto;\n    padding: 1px 29px;\n    padding-top: 10px;\n  }\n\n  .app-bar .app-bar__menu {\n    display: none;\n  }\n\n  .app-bar .app-bar__navigation {\n    position: static;\n    width: 100%;\n  }\n\n  .app-bar .app-bar__navigation ul li {\n    display: inline-block;\n  }\n\n  .app-bar .app-bar__navigation ul li a {\n    display: inline-block;\n    width: 120px;\n    text-align: center;\n    font-size: 1.1em;\n    padding-top: 14px;\n  }\n}\n\n/* Set the grid */\n@media screen and (min-width: 505px) {\n  .restaurant {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n@media screen and (min-width: 650px) {\n  .restaurant {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n@media screen and (min-width: 950px) {\n  .restaurant {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media screen and (min-width: 1200px) {\n  .restaurant {\n    grid-template-columns: repeat(4, 1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
